import { PdfEntityByAcademicYearList } from 'components/pdfStudent';
import { splitEntitiesByAcademicYear } from 'containers/pdfStudent/utils/splitEntitiesByAcademicYear';
import { useAppSelector, useDataLoad } from 'hooks';
import { IconWidgetSportContests } from 'icons/widgets';
import PdfNoDataText from 'portfolio3/features/pdf/components/PdfNoDataText';
import { chosenAcademicYearsListSelector } from 'portfolio3/features/pdf/model/selectors';
import { getDataLoadRequests } from 'utils';

import { sportCompetitionsSelector } from '../../../../selectors';
import PdfCommonDataEntityContainer from '../common';

import '../index.scss';

const PdfSportCompetitionContainer = () => {
  const academicYears = useAppSelector(chosenAcademicYearsListSelector);
  const studentCompetitions = useAppSelector(sportCompetitionsSelector);
  useDataLoad({ shouldLoad: true, requests: getDataLoadRequests().sportCompetitions });

  const hasData = studentCompetitions.content.length > 0;
  const academicYearData = splitEntitiesByAcademicYear(studentCompetitions, academicYears);

  return (
    <PdfCommonDataEntityContainer title="Соревнования" Icon={IconWidgetSportContests}>
      {hasData && <PdfEntityByAcademicYearList academicYearData={academicYearData} />}
      {!hasData && <PdfNoDataText />}
    </PdfCommonDataEntityContainer>
  );
};

export default PdfSportCompetitionContainer;
